import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import InvestmentMetric from './InvestmentMetric';
import LoadingIndicator from '../../Common/LoadingIndicator';
import { NoContent } from '../../Common/NoContent';
import { useErrorHandler } from "react-error-boundary";
import { FC } from 'react';
import { IActiveInvestmentMetric } from '../../../interfaces/metrics';

type Props = {
  error: Error | null;
  fetching: boolean;
  activeInvestmentMetrics: IActiveInvestmentMetric[];
};

const InvestmentMetrics: FC<Props> = ({error, fetching, activeInvestmentMetrics}) => {
  useErrorHandler(error)

  const settings = {
    dots: true,
    infinite: true,
    autoplay: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  return (
      <div className='card'>
        <div className='card-body'>
          <Slider {...settings}>
            {(fetching && activeInvestmentMetrics.length < 1) ? <LoadingIndicator message='' /> : activeInvestmentMetrics.map((activeInvestment) => {
              return <InvestmentMetric key={activeInvestment.id} activeInvestment={activeInvestment} />
            })}
            {(!error && !fetching && activeInvestmentMetrics.length < 1) && <NoContent message='No metrics are available' />}
          </Slider>
        </div>
      </div>
  );
};

export default InvestmentMetrics;
